import { useQuery } from '@apollo/client';
import ErrorPage from '@website/components/utilities/ErrorPage';
import LoadingPage from '@website/components/utilities/LoadingPage';
import { GroupForBroadcastMessageToGroupDocument } from '@website/types/graphqlOperations';
import { DateTime } from 'luxon';
import { Alert, Breadcrumb } from 'react-bootstrap';
import Link from 'next/link';
import BroadcastMessageToGroupForm from './BroadcastMessageToGroupForm';

type Props = {
  groupID: string;
  hostURL: string;
};

export default function BroadcastMessageToGroup({ groupID, hostURL }: Props) {
  const { data, error, loading } = useQuery(
    GroupForBroadcastMessageToGroupDocument,
    {
      variables: {
        groupID,
      },
    },
  );

  if (loading) {
    return <LoadingPage />;
  }

  if (error) {
    return <ErrorPage error={error} />;
  }

  const departingDate = DateTime.fromISO(data.group.start.utc, {
    zone: data.group.start.zone,
  }).toFormat('dd LLL yyyy');

  return (
    <>
      <Breadcrumb className="py-3">
        <Link href={`/hosts/dashboard/${hostURL}`} passHref legacyBehavior>
          <Breadcrumb.Item href="">Host Dashboard</Breadcrumb.Item>
        </Link>
        <Link
          href={`/hosts/dashboard/${hostURL}/bookings`}
          passHref
          legacyBehavior
        >
          <Breadcrumb.Item>Bookings</Breadcrumb.Item>
        </Link>
        <Breadcrumb.Item>
          {data.group.trip.title} -{' '}
          {DateTime.fromISO(data.group.start.utc, {
            zone: data.group.start.zone,
          }).toLocaleString(DateTime.DATETIME_MED)}
        </Breadcrumb.Item>
        <Breadcrumb.Item active>Message Group</Breadcrumb.Item>
      </Breadcrumb>
      <h4>
        Send message to Guests on {data.group.trip.title} departing on{' '}
        {departingDate}
      </h4>
      <Alert>
        <strong>Please only send messages about this trip</strong>
        <p>
          Please note marketing is strictly prohibited. This means you should
          avoid asking customers to follow you on social media, or use other
          channels/websites.
        </p>
      </Alert>
      <BroadcastMessageToGroupForm groupID={data.group.id} />
    </>
  );
}
